export default __webpack_public_path__ + "static/media/manual4.de458a3d.png";